import { render, staticRenderFns } from "./Clienti_dialog.vue?vue&type=template&id=206d9e28&scoped=true&"
import script from "./Clienti_dialog.vue?vue&type=script&lang=js&"
export * from "./Clienti_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Clienti_dialog.vue?vue&type=style&index=0&id=206d9e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d9e28",
  null
  
)

export default component.exports